import { render, staticRenderFns } from "./LogbookIcon.vue?vue&type=template&id=539281c8"
import script from "./LogbookIcon.vue?vue&type=script&lang=js"
export * from "./LogbookIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports